import React from "react";
import { Tab } from "@material-ui/core";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import { Values } from "@src/Tools/Values";
import { STTabs } from "./styles";
import { RouterStore } from "mobx-react-router";

@inject("routing")
@observer
class LoginTabs extends React.Component<{ routing?: RouterStore}> {
  @observable value: number = 0;
  private useOAuthRoutes = false;

  constructor(props: any) {
    super(props);
    if (this.props.routing.location.pathname.match("/pin")) {
      this.value = 1;
    } else {
      this.value = 0;
    }
    if (this.props.routing.location.pathname.match("/Auth/Authorize")) {
        this.useOAuthRoutes = true;
    }
  };

  handleChange = (event: React.ChangeEvent<{}>, value: any) => {
    this.value = value;
    let pathForUser =  this.useOAuthRoutes ? "/Auth/Authorize" : "/login";

    if (value === 0) {
      this.props.routing.history.push({
        pathname: pathForUser,
        search: this.props.routing.location.search,
      });
    } else {
      this.props.routing.history.push({
        pathname: pathForUser + "/pin",
        search: this.props.routing.location.search,
      });
    }
  };

  render() {
    return (
      <STTabs value={this.value} onChange={this.handleChange}>
        <Tab label={Values.getLocalizationValue("standardLogin")} />
        <Tab label={Values.getLocalizationValue("quickLogin")} />
      </STTabs>
    );
  }
}

export default LoginTabs;
